<template>
  <div id="app">
    <ModalAll v-if="selectedSpot" v-show="shoModalAll" />
    <HelpModal v-show="showHelpModal" />
    <Loading v-show="loading" />
    <MiniLoading v-show="miniLoading && !loading" />
    <router-view v-show="!loading"/>
    <!-- <Home v-show="!loading"></Home> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalAll from '@/components/Pages/ModalAll'
import HelpModal from '@/components/Pages/HelpModal'
import Loading from '@/components/Organisms/Loading'
import MiniLoading from '@/components/Organisms/MiniLoading'
export default {
  name: 'App',
  components: {
    HelpModal,
    ModalAll,
    Loading,
    MiniLoading
  },
  computed: {
    ...mapState([
      'loading',
      'shoModalAll',
      'selectedSpot',
      'showHelpModal',
      'miniLoading'
    ])
  }
}
</script>

<style>
html {
  height: 100%;
}
body{
  /* display: flex; */
  margin:0;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  height:100%;
  position:relative;
  /* background-color:red ; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue